export default __webpack_public_path__ + "static/media/DAVANStategic.21780198.jpg";